import { solutionConstants } from './solutionsConstants';
import { profileTypes } from './userConstants';

const defaultServiceProfileRules = {
  [profileTypes.OPERATOR.id]: {
    profileData: profileTypes.OPERATOR,
    allowSelectCurrentUser: true,
    showAddress: false,
    showFinalCustomerSwitch: false,
    showPriority: false,
    prioritizeReference: true,
    showCheckRepeatAppointment: false,
    enableSearchFinalCustomer: true,
    enableDropdown: false,
    disableOrigin: false,
    disableCollaborators: false,
  },
  default: {
    profileData: profileTypes.TECHNICIAN,
    allowSelectCurrentUser: false,
    showAddress: true,
    showFinalCustomerSwitch: true,
    showPriority: true,
    prioritizeReference: false,
    showCheckRepeatAppointment: true,
    enableSearchFinalCustomer: false,
    enableDropdown: true,
    disableOrigin: false,
    disableCollaborators: false,
  },
};

const tapptusRules = {
  serviceName: true,
  showAddress: false,
  origin: true,
  collaborators: true,
  assets: false,
  showFinalCustomerAlways: false,
  useCompanyAddress: false,
  useContactAddress: true,
  useFinalCustomerAddress: true,
  useHeadquartersAddress: false,
  prioritizeReference: true,
  profileRules: defaultServiceProfileRules,
  enabledActionsContact: true,
  checkMinDate: false,
};

const micitaRules = {
  serviceName: false,
  showAddress: true,
  origin: false,
  collaborators: false,
  assets: true,
  showFinalCustomerAlways: true,
  useCompanyAddress: false,
  useHeadquartersAddress: true,
  finalCustomerRequired: true,
  profileRules: defaultServiceProfileRules,
  checkMinDate: true,
};

const serviceSolutionRules = {
  [solutionConstants.TAPPTUS.id]: tapptusRules,
  [solutionConstants.MICITA.id]: micitaRules,
  [solutionConstants.MIENCUESTA.id]: micitaRules,
  [solutionConstants.APHMED.id]: { ...tapptusRules, enabledActionsContact: false },
  [solutionConstants.MIEMERGENCIA.id]: {
    ...tapptusRules,
    useFinalCustomerAddress: false,
    collaborators: false,
    useContactAddress: true,
    profileRules: {
      [profileTypes.OPERATOR.id]: {
        ...defaultServiceProfileRules[profileTypes.OPERATOR.id],
        finalCustomerRequired: false,
        disableOrigin: true,
        disableDestination: true,
        disableCollaborators: true,
      },
      default: {
        ...defaultServiceProfileRules.default,
        finalCustomerRequired: false,
        disableOrigin: false,
        disableCollaborators: false,
      },
    },
  },
  default: micitaRules,
};

export { serviceSolutionRules, defaultServiceProfileRules };
